import React, { useState, useEffect } from 'react';
import '../index.css';
import './editTable2.css';
import {
  searchRecordInAirTable,
  updateRecordInAirTable,
  createRecordInAirTable
} from '../functions.js/airTableDB';

const AutomationsPage = () => {
  const [automations, setAutomations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newAutomation, setNewAutomation] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const fetchedAutomations = await searchRecordInAirTable('automations');
      setAutomations(fetchedAutomations || []);
      setIsLoading(false);
    };

    fetchData();
  }, []);

  if (isLoading) {
    return <p>Lade Daten...</p>;
  }

  return (
    <div className="automations-container modernContainer">
      <h2>Automatisierungen</h2>
      <AutomationsTable
        automations={automations}
        setAutomations={setAutomations}
        newAutomation={newAutomation}
        setNewAutomation={setNewAutomation}
      />
    </div>
  );
};

const AutomationsTable = ({ automations, setAutomations, newAutomation, setNewAutomation }) => {
  const [editedAutomations, setEditedAutomations] = useState({});
  const [originalAutomations, setOriginalAutomations] = useState({});

  useEffect(() => {
    const edits = {};
    const originals = {};

    automations.forEach(automation => {
      edits[automation.id] = {
        name: automation.fields?.name || ''
      };
      originals[automation.id] = { ...edits[automation.id] };
    });

    setEditedAutomations(edits);
    setOriginalAutomations(originals);
  }, [automations]);

  const handleInputChange = (automationId, field, value) => {
    setEditedAutomations(prev => ({
      ...prev,
      [automationId]: {
        ...prev[automationId],
        [field]: value
      }
    }));
  };

  const hasChanges = (automationId) => {
    const original = originalAutomations[automationId] || {};
    const current = editedAutomations[automationId] || {};
    return original.name !== current.name;
  };

  const validateAutomation = (automationData) => {
    return automationData.name.trim() !== '';
  };

  const handleSave = async (automationId) => {
    if (!hasChanges(automationId)) return;

    const current = editedAutomations[automationId];
    if (!validateAutomation(current)) {
      alert('Bitte Namen ausfüllen.');
      return;
    }

    const updatedData = {
      name: current.name
    };

    await updateRecordInAirTable(automationId, updatedData, 'automations');

    setAutomations(prev =>
      prev.map(automation =>
        automation.id === automationId
          ? { ...automation, fields: { ...automation.fields, ...updatedData } }
          : automation
      )
    );
    setOriginalAutomations(prev => ({
      ...prev,
      [automationId]: { ...current }
    }));
  };

  const handleDiscard = (automationId) => {
    setEditedAutomations(prev => ({
      ...prev,
      [automationId]: { ...originalAutomations[automationId] }
    }));
  };

  const handleNewSave = async () => {
    if (!newAutomation || !validateAutomation(newAutomation)) {
      alert('Bitte Namen ausfüllen.');
      return;
    }

    const newData = {
      name: newAutomation.name
    };

    const result = await createRecordInAirTable(newData, 'automations');
    if (result) {
      setAutomations(prev => [...prev, result]);
      setNewAutomation(null);
    }
  };

  return (
    <>
      <table className="modern-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {automations.map(automation => (
            <tr key={automation.id}>
              <td>
                <input
                  type="text"
                  value={editedAutomations[automation.id]?.name || ''}
                  onChange={(e) => handleInputChange(automation.id, 'name', e.target.value)}
                />
              </td>
              <td className="actions-td">
                {hasChanges(automation.id) && (
                  <>
                    <button className="btn save" onClick={() => handleSave(automation.id)}>
                      💾
                    </button>
                    <button className="btn discard" onClick={() => handleDiscard(automation.id)}>
                      ✖
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}

          {newAutomation && (
            <tr className="new-row">
              <td>
                <input
                  type="text"
                  placeholder="Name"
                  value={newAutomation.name}
                  onChange={(e) => setNewAutomation({ ...newAutomation, name: e.target.value })}
                />
              </td>
              <td className="actions-td">
                <button className="btn save" onClick={handleNewSave}>
                  💾
                </button>
                <button className="btn discard" onClick={() => setNewAutomation(null)}>
                  ✖
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {!newAutomation && (
        <button
          className="btn new-group"
          onClick={() => setNewAutomation({ name: '' })}
        >
          + Neue Automatisierung
        </button>
      )}
    </>
  );
};

export default AutomationsPage;